export enum CodesReports {               // nom G+
    BonLivraisonBonRetour = 'BLR',       // BLBR / BLR
    ContratLocation = 'CLO',             // CLO
    Factures = 'FACTURES',               // FACTURES
    FactureVente = 'FACVTE',             // FACTURE_VENTE
    FactureVenteTVA = 'FAC_TVA',         // FACTURE_VENTE_TVA
    FactureLocation = 'FACLOC',          // FACTURE_LOC
    FactureFournisseur = 'FACFOU',       // FACTURE_FOUR
    RecuVente = 'RCV',                   // RCV
    CommandeVente = 'CDEVTE',            // CDEVTE
    CO1 = 'CO1',                         // CO1
    CO2 = 'CO2',                         // CO2
    FA1 = 'FA1',                         // FA1
    CO3 = 'CO3',                         // CO3
    BL1 = 'BL1',                         // BL1
    COUSP = 'COUSP',                     // COUSP
    ETA1 = 'ETA1',                       // ETA1
    ETA2 = 'ETA2',                       // ETA2
    CPTPLAN = 'CPTPLAN',                 // CPTPLAN
    BAL1 = 'BAL1',                       // BAL1
    BAL2 = 'BAL2',                       // BAL2
    GDL1 = 'GDL1',                       // GDL1
    GRAND_LIVRE_AVANCE = 'GDLA',         // GRAND_LIVRE_AVANCE
    GRAND_LIVRE_ANA_AVANCE = 'GDAA',     // GRAND_LIVRE_ANA_AVANCE
    GDL2 = 'GDL2',                       // GDL2
    JRN1 = 'JRN1',                       // JRN1
    LSTART = 'LSTART',                   // LSTART
    LettreCheque = 'LCHQ',               // LCHQ
    LCHD = 'LCHD',                       // LCHD
    RAP = 'RAP',                         // RAP
    Inventaire = 'INV1',                 // INV1
    COM1 = 'COM1',                       // COM1
    REM = 'REM',                         // REM
    FA2 = 'FA2',                         // FA2
    COM2 = 'COM2',                       // COM2
    FA3 = 'FA3',                         // FA3
    BDG = 'BDG',                         // BDG
    BGS = 'BGS',                         // BGS
    DISLOC = 'DISLOC',                   // DISLOC
    EMARGEMENT = 'EMA',                  // EMA
    BALANA = 'BALANA',                   // BALANA
    RESERVATION = 'RES',                 // RES
    TAB = 'TAB',                         // TAB
    GLVANA = 'GLVANA',                   // GLVANA
    CPTRSL = 'CPTRSL',                   // CPTRSL
    BILAN = 'BILAN',                     // BILAN
    DRP = 'DRP',                         // DRP
    BVB = 'BVB',                         // BVB
    CommandeFournisseur = 'CDEFOU',      // CDEFOU
    TBDGGP = 'TBDGGP',                   // TBDGGP
    EMR = 'EMR',                         // EMR
    ETQADR2x6 = 'ETQADR2x6',             // ETQADR2x6
    ETQADR2x8 = 'ETQADR2x8',             // ETQADR2x8
    ETQADR3x7 = 'ETQADR3x7',             // ETQADR3x7
    ETQCDB2x7 = 'ETQCDB2x7',             // ETQCDB2x7
    ETQCDB3x11 = 'ETQCDB3x11',           // ETQCDB3x11
    ETQCDB3x7 = 'ETQCDB3x7',             // ETQCDB3x7
    ETQCDB4x21 = 'ETQCDB4x21',           // ETQCDB4x21
    ETQCDB5x13 = 'ETQCDB5x13',           // ETQCDB5x13
    LOCACC = 'LOCACC',                   // LOCACC
    LOCREF = 'LOCREF',                   // LOCREF
    TBF = 'TBF',                         // TBF
    BFO = 'BFO',                         // BFO
    BFA = 'BFA',                         // BFA
    BFP = 'BFP',                         // BFP
    HFA = 'HFA',                         // HFA
    BVA = 'BVA',                         // BVA
    DOSSIER_EVENEMENTS_FAM = 'DPEFR',    // DOSSIER_EVENEMENTS_FAM
    ETAT_STOCKS = 'EST',                 // ETAT_STOCKS
    ENGAGEMENT_BUDGETAIRE = 'EBU',       // ENGAGEMENT_BUDGETAIRE
    FICHE_RENS_ADMIN = 'FICHRA_PE_NPDC', // FICHE_RENS_ADMIN
    FICHE_CALC_COEFF = 'COEF_PE_NPDC',   // FICHE_CALC_COEFF
    ENG_BUDG_ECRITURE = 'ENG_BUDG_ECRITURE',  // ENG_BUDG_ECRITURE
    CAISART = 'CAISART',                 // CAISART
    DETAIL_ARRETE_CAISSE = 'DAC',        // DETAIL_ARRETE_CAISSE
    ETQMENU2x6 = 'ETQMNU2x6',            // ETQMENU2x6
    ETQMENU2x8 = 'ETQMNU2x8',            // ETQMENU2x8
    ETQMENU3x7 = 'ETQMNU3x7',            // ETQMENU3x7
    REMISE_CAISSE = 'CAISREM',           // REMISE_CAISSE
    DETAIL_REMISE_CAISSE = 'DREMC',      // DETAIL_REMISE_CAISSE
    TICKET_CAISSE = 'TCS',               // TICKET_CAISSE
    TICKET_CAISSE_TVA = 'TCSTVA',        // TICKET_CAISSE_TVA
    DOSSIER_PRET = 'DOSPRET',            // DOSSIER_PRET
    TRANSFERT_STOCK_MDK = 'TRFSTK',      // TRANSFERT_STOCK_MDK
    COURRIER_PUBLIPOSTAGE = 'PUBCOUR',   // COURRIER_PUBLIPOSTAGE
    IMPRESSION_FORMULAIRE = 'FORMUL',    // IMPRESSION_FORMULAIRE
    BON_ATTRIBUTION_MDK = 'MDKBL',       // BON_ATTRIBUTION_MDK
    DOSSIER_EPARGNE = 'EPADOS',          // DOSSIER_EPARGNE
    COMPTE_RESULTAT_SIMPLIFIE = 'CPTRSLS', // COMPTE_RESULTAT_SIMPLIFIE
    BILAN_SIMPLIFIE = 'BILANS',            // BILAN_SIMPLIFIE
    FICHE_SIGNALETIQUE = 'FICHE_SIGNA',  // FICHE_SIGNALETIQUE
    ROOMING_LIST = 'ROOMING_LIST',       // ROOMING_LIST
    PLANNING_OCCUPATION = 'PLANNING_OCCUPATION', // PLANNING_OCCUPATION
    FEUILLE_EMARGEMENT = 'LIST_EMARG',   // FEUILLE_EMARGEMENT
    DECLARATION_TVA = 'DECLARATION_TVA', // DECLARATION_TVA
    REPORT_DOSSIER_EPARGNE = 'EPADOS', //REPORT DOSSIER EPARGNE
    ETIQUETTE_COURRIER = 'EQC',        // EQC
    ETIQUETTE_ADRESSE = 'EQA',         // EQA
    INVITATION_SYNAPSE = 'INVITATION_SYNAPSE' // INVITATION_SYNAPSE
}

export enum CodesTypesReports {
    IMPRESSION_FORMULAIRE = 'FRM',
    DOSSIER_PRET = 'PRT',
    LETTRE_CHEQUE = 'LCH',
    CADEAU = 'CAD',
    DOSSIER_EVENEMENTS_FAM = 'DEF'
}
